(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__shipBadgeInit) return;
    window.__shipBadgeInit = true;

    var CARD = 'product-card, .product-card';

    function setSpeed(badges, speed) {
      badges.forEach(function (el) {
        el.querySelectorAll('[data-speed]').forEach(function (b) {
          var hide = b.getAttribute('data-speed') !== speed;
          if (b.hidden !== hide) b.hidden = hide;
        });
      });
    }

    /* Badges van hetzelfde product: dichtstbijzijnde voorouder met badges,
       zonder badges van ándere productkaarten (bv. aanbevelingen). */
    function badgesNear(startEl) {
      var ownCard = startEl.closest(CARD);
      var node = startEl.parentElement;
      while (node && node !== document.documentElement) {
        var list = Array.prototype.filter.call(
          node.querySelectorAll('[data-ship-badge]'),
          function (el) { return el.closest(CARD) === ownCard; }
        );
        if (list.length) return list;
        node = node.parentElement;
      }
      return [];
    }

    /* 1. Productpagina: badge volgt altijd de verzendtekst onder de prijs
          (data-pdp-shipping-note), die per gekozen maat klopt. */
    function syncFromNotes() {
      document.querySelectorAll('[data-pdp-shipping-note]').forEach(function (note) {
        var speed = note.getAttribute('data-shipping-speed') || 'standard';
        setSpeed(badgesNear(note), speed);
      });
    }

    var queued = false;
    function queueSync() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncFromNotes(); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncFromNotes);
    } else {
      syncFromNotes();
    }

    /* Opnieuw synchroniseren als het thema de pagina (deels) opnieuw opbouwt
       of de verzendtekst verandert. */
    new MutationObserver(queueSync).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-shipping-speed']
    });

    /* 2. Maat aanklikken (ook op productkaarten met een maatkiezer) */
    document.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="radio"][data-variant-id]');
      if (!input) return;
      var speed = input.getAttribute('data-shipping-speed') || 'standard';
      setSpeed(badgesNear(input), speed);
      queueSync();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
